import React from "react";

import { classNames } from "@/lib/util";
import { translate } from "../IntlProviderWrapper";

import "./SearchInput.scss";

type SearchInputProps = {
    value: string;
    size?: "sm";
    placeholder?: string;
    className?: string;
    disabled?: boolean;
    onChange: (value: string) => void;
};

/**
 * A reusable search input component with clear button.
 */
const SearchInput = (props: SearchInputProps) => {
    const {
        value,
        size,
        className = "",
        placeholder = translate("common.search", "Search"),
        disabled = false,
        onChange,
    } = props;

    const handleClear = () => {
        onChange("");
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.currentTarget.value);
    };

    return (
        <div
            className={classNames("search-input", className, {
                "search-input--sm": size === "sm",
                "is-disabled": disabled,
            })}
        >
            <i className="search-input__icon fas fa-search" />
            <input
                type="text"
                className={classNames("search-input__field form-control", {
                    "form-control-sm": size === "sm",
                })}
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                disabled={disabled}
            />
            {value && !disabled && (
                <button
                    className="search-input__clear btn btn-clean"
                    onClick={handleClear}
                    type="button"
                    title={translate("common.clear", "Clear")}
                >
                    <i className="fas fa-times" />
                </button>
            )}
        </div>
    );
};

export default SearchInput;
